<template>
  <div id="app">
    <router-view/>
    <div class="spacer"></div>
    <footer>
      <p>test</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (this._isIphone()) {
      this.$router.replace('/ios_index');
    } else if (this._isMobile()) {
      this.$router.replace('/m_index');
    } else {
      this.$router.replace('/pc_index');
    }
  },
  methods: {
    _isIphone() {
      let flag = navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)
      return flag;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
};
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex: 1;
}

header {
  padding: 120px 0 0 0;
}

body {
  margin: 0;
  background-color: #eee;
}

footer {
  padding: 1rem;
  background-color: #efefef;
  text-align: center;
  color: #efefef;
  font-weight: 200;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue